module.exports = __webpack_public_path__ + "custom-config/img/certification.1c5d039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/certification.png
// module id = qNZ7
// module chunks = 2 3 4 6 7 8 9